











































































import {Component, Ref, Vue, Watch} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import {FormRowWings, SelectWings, InputWings, TextareaWings} from "wings-ui-components";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {AddressBookItem} from "@/store/addressbooks/types";
import { ActionLog } from "@/store/auth/types";
import { getTranslatedParams } from "@/utils/notify-utils";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: {FormRowWings, SelectWings, InputWings, TextareaWings}})
export default class AddressBook extends Vue{
  @Ref('validator') validator:any;
  @Action("getAddressBookItem") actionGetItem: any;
  @Action("saveAddressBook") actionSave: any;
  @Action("deleteAddressBook") actionDelete: any;
  @Action("actionLog") actionLog: any;

  private item = new AddressBookItem()
  private itemSaved = new AddressBookItem()
  private checkDuplicates = true
  logObject: ActionLog = {}

  policiesMap = {
    1: this.$t('contacts.checkDuplicatesPolicies.msisdn').toString(),
    2: this.$t('contacts.checkDuplicatesPolicies.email').toString(),
    3: this.$t('contacts.checkDuplicatesPolicies.msisdn_email').toString(),
    4: this.$t('contacts.checkDuplicatesPolicies.all').toString()
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Viewing",
          actionStatus: 'success',
          objectType: "Address book",
          objectName: this.item.name,
        }
        const data = await this.actionGetItem(this.$route.params.id)
        if (data.checkDuplicatesPolicy === 0) this.checkDuplicates = false;
        this.item = Object.assign({},this.item, data);
        this.itemSaved = cloneDeep(Object.assign({},this.item, data));
        this.logObject.objectName = this.item.name
        await this.actionLog(this.logObject)
      } catch (error) {
        notifyError(error);
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
      }
    }
  }

  back() {
    this.$router.push('/address_book/group');
  }

  onSaveItem():Promise<void> {
    return new Promise( async (resolve, reject) => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        return
      }
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          actionStatus: 'success',
          objectType: "Address book",
          objectName: this.item.name,
          addititionalInfo: getTranslatedParams({
            comment: this.item.comment,
            //@ts-ignore
            checkDuplicatesPolicy: this.policiesMap[this.item.checkDuplicatesPolicy]})
        }
        if (!this.item.checkDisposable) this.item.checkDisposable = 0
        if (!this.item.checkRoleBased) this.item.checkRoleBased = 0
        if (!this.item.checkExistence) this.item.checkExistence = 0
        await this.actionSave(this.item);
        await this.actionLog(this.logObject)
        this.itemSaved = cloneDeep(this.item);
        resolve()
        this.back();
      } catch (error) {
        reject()
        notifyError(error);
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
      }
    })
  }

  async onDeleteItem():Promise<void> {
    if (!await notifyDelete()) return
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Removal",
        actionStatus: 'success',
        objectType: "Address book",
        objectName: this.item.name,
        addititionalInfo: getTranslatedParams({id: this.item.groupId})
      }
      await this.actionDelete({groupId: this.item.groupId})
      await this.actionLog(this.logObject)
      this.itemSaved = this.item;
      this.back();
    } catch (error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  @Watch('checkDuplicates', {immediate: true})
  onChangeCheckDuplicates(val?: boolean) {
    if (!val) {
      this.item.checkDuplicatesPolicy = 0
    } else {
      this.item.checkDuplicatesPolicy = 3
    }
  }

}
